import { Col, Container, Image, Row, Form, Button } from "react-bootstrap";
import { useState } from "react";
import { localAuthenticate } from "../services/user-master-service";
// import LoginImage from "../images/LoginImage.jpg";
import godrejlogo from "../images/godrej-logo-login-header.svg"

export default function LoginLocalAuth({ setIsAuthenticated }) {
  const [userName, setUserName] = useState("");
  function handleLogin() {
    localAuthenticate(userName).then((resp) => {
      if (resp) {
        sessionStorage.setItem("Token", resp.Token);
        sessionStorage.setItem("UserData", JSON.stringify(resp.UserData));
        alert("Login successful");
        setIsAuthenticated(true);
      } else {
        alert("Please check your username and password");
      }
    });
  }

  return (
    <Container className="login-container">
      <Row className="login-width">
        <Col xs={12}>
          <div class="d-flex justify-content-between align-items-center my-3 logoHeader">
            <img src={godrejlogo} />
            <span class="headerLink">Godrej Enterprises Group</span>
          </div>
        </Col>
        <Col md={8}>
          {/* <Image src={LoginImage} alt="Login_Image" /> */}
          <div className="login-container-left"></div>
        </Col>
        <Col
          md={4}
          className="d-flex flex-column justify-content-center min-vh-100 login-container-right"
        >
          <h2 className="app-name">
            Online Design
            <br />
            Release System
            <br />
          </h2>
          <div className="field">
            <Form>
              <Form.Label htmlFor="username">Username</Form.Label>
              <input
                className="input"
                name="username"
                type="text"
                placeholder="Username"
                id="username"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </Form>
          </div>
          <Button
            variant="primary" className="login-btn"
            onClick={handleLogin}
          >
            Login
          </Button>
          {/* <div className="brand mt-auto">
            Ideated By Godrej Construction
            <br /> Designed And Developed By Godrej Infotech
          </div> */}
        </Col>
      </Row>
    </Container>
  );
}
